import { ApiResponse } from 'src/types/response';
import { endpoints, axiosInstance } from 'src/utils/axios';
import { FileType } from '../../../../libs/file-uploader/src/lib/domain/file';

export async function uploadFile(
  file: File,
  onProgress: (progress: number) => void,
) {
  const formData = new FormData();
  formData.append('file', file);
  const URL = endpoints.file.upload;
  const res = await axiosInstance.post<ApiResponse<{ file: FileType }>>(
    URL,
    formData,
    {
      onUploadProgress(progressEvent) {
        onProgress(progressEvent.progress ?? 0);
      },
    },
  );
  return res;
}

export async function uploadFiles(
  files: File[],
  onProgress: (progress: number) => void,
) {
  const formData = new FormData();
  files.forEach((file: File) => {
    formData.append(`files`, file);
  });

  const URL = endpoints.file.uploadFiles;

  const res = await axiosInstance.post(URL, formData, {
    onUploadProgress(progressEvent) {
      onProgress(progressEvent.progress ?? 0);
    },
  });

  return res;
}
